module.exports = __webpack_public_path__ + "img/PEBL-Logo-White-small.5157c2f6.png";